/* import __COLOCATED_TEMPLATE__ from './feature-detail.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();